<template>
  <div v-if="isFirstBooking" class="d-inline-flex align-items-center">
    <div class="badge-status text-status status-first-reservation">First Reservation</div>
  </div>
</template>

<script>
/**
 * Header badge for the first booking of a customer (the agent when the booking
 * has one, otherwise the customer), so Customer Service can review it.
 */
export default {
  name: "FirstBookingBadge",
  props: {
    isFirstBooking: {
      type: Boolean,
      default: false,
      description: "Whether the reservation is its customer's first reservation"
    }
  }
};
</script>
